module.exports = __webpack_public_path__ + "media/images/faces/female/12-35bc8fa416b9784384cbaa02bb3464fc.jpg";